module.exports = __webpack_public_path__ + "media/images/email/digi_wed_poster-4f9a1ea400c49b8f3e122527b1edabfb.png";